import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';

import { catchError, from, switchMap, throwError } from 'rxjs';
import { DISABLE_REFRESH_TOKEN_INTERCEPTOR } from '@hglobal/common';
import { environment } from '@fb/environments';

import { AuthService } from './auth.service';
import { shouldSkipRenewal } from './auth-http.helpers';

export function refreshTokenInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn,
) {
  if (environment.useMocks || ignoreRefreshToken(request) || shouldSkipRenewal(request.url)) {
    return next(request);
  }

  const authService = inject(AuthService);

  return next(request).pipe(
    catchError(error => {
      if (!isUnauthorized(error)) {
        return throwError(() => error);
      }

      return from(authService.renewSession()).pipe(
        switchMap(() => next(request)),
        catchError(() => throwError(() => error)),
      );
    }),
  );
}

function ignoreRefreshToken(request: HttpRequest<any>): boolean {
  return request.context.get(DISABLE_REFRESH_TOKEN_INTERCEPTOR);
}

function isUnauthorized(error: unknown): boolean {
  if (error instanceof HttpErrorResponse) {
    return error.status === HttpStatusCode.Unauthorized;
  }

  const status = (error as { originalError?: { status?: number }; status?: number })
    .originalError?.status
    ?? (error as { status?: number }).status;

  return status === HttpStatusCode.Unauthorized;
}
